<template>
  <div>
    <template v-if="loading">
      <b-skeleton-table
        :rows="8"
        :columns="1"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>         
    </template>
    <template v-else>
      <div class="mb-5" v-if="periodGoals.minMP">
        <h3 class="ml-2 mb-3">Общие результаты B2B за месяц</h3>
        <div class="results-row">
            <div 
                class="results-column"
                :class="periodGoals.minMP.solved ? 'results-column__success':''"
            >
                <!-- <b>{{ periodGoals.minMP.title }}</b> -->
                <div>Точка безубыточности компании: 
                    <span 
                        class="bigNumber" 
                    >{{ periodGoals.minMP.sum | toCurrency }}</span>&nbsp;р.                        
                </div>
                <div>Маржинальная прибыль компании за месяц, без НДС: <span class="bigNumber">{{ periodGoals.minMP.result | toCurrency }}</span>&nbsp;р.</div>
                <!-- <div>Осталось до достижения результата: <span class="bigNumber">{{ periodGoals.minMP.full_debt | toCurrency }}</span>&nbsp;р.</div> -->
            </div>
        </div>
    </div>

      <h3 class="pl-2 mt-5">{{ motivationHeader }}</h3>

      <div class="row mt-4">
        <div class="col-md-6 text-center">
          <vue-speedometer
            :width="400"
            :value="toShortMillions(scoredMotivation.parameters[0].mpd)"
            needleColor="steelblue"
            :needleTransitionDuration="4000"
            needleTransition="easeElastic"
            currentValueText="МП отдела: ${value} млн"
            textColor="${textColor}"
            :customSegmentStops="departamentSegmentStops.values"
            :minValue="departamentSegmentStops.values[0]"
            :maxValue="departamentSegmentStops.values[departamentSegmentStops.values.length - 1]"
            :segmentColors='["#E57A27", "#FFD700", "#90EE90", "#0F6348"]'
          />
        </div>
        <div class="col-md-6 text-center">
          <vue-speedometer
            :width="400"
            :value="toShortMillions(scoredMotivation.parameters[0].mpp)"
            needleColor="steelblue"
            :needleTransitionDuration="4000"
            needleTransition="easeElastic"
            currentValueText="Личная МП: ${value} млн"
            textColor="${textColor}"
            :customSegmentStops="personalSegmentStops.values"
            :minValue="personalSegmentStops.values[0]"
            :maxValue="personalSegmentStops.values[personalSegmentStops.values.length - 1]"
            :segmentColors='["#0F6348", "#90EE90"]'
          />
        </div>
      </div>
      <table class="table table-hover outlined table-fixed table-max-font-size">
        <!-- <tr>
          <th class="bg-green-light">100% KPI Отдела</th>
          <td class="bg-gray-light">{{ scoredMotivation.parameters[0].kpi.value | toCurrency }} р.</td>
        </tr> -->
        <!-- <tr>
			<th class="bg-green-light">Маржинальная прибыль компании</th>
			<td class="bg-gray-light">{{ scoredMotivation.parameters[0].mpa | toCurrency }} р.</td>
		</tr> -->
		<tr>
			<th class="bg-green-light">Маржинальная прибыль отдела</th>
			<td class="bg-gray-light">{{ scoredMotivation.parameters[0].mpd | toCurrency }} р.</td>
		</tr>
		<tr>
          <th class="bg-green-light">Личная маржинальная прибыль</th>
          <td class="bg-gray-light">
            <template v-if="scoredMotivation.parameters[0].mpp != 0">
              <span class="cursor-pointer link-underline" @click="showMotivationByUserId(scoredMotivation.parameters[0].finance_ids, [scoredMotivation.user.id])">{{ scoredMotivation.parameters[0].mpp | toCurrency }}&nbsp;р.</span>
            </template>
            <template v-else>
              0 р.
            </template>
          </td>
        </tr>
        <tr>
          <th class="bg-green-light">Бонус по результатам отчетного периода</th>
          <td class="bg-gray-light">
            <div title="Бонус по KPI">{{ scoredMotivation.motivation_bonus | toCurrency }}&nbsp;р.<span v-if="scoredMotivation.motivation_bonus > 0">&nbsp;({{ scoredMotivation.parameters[0].mpp_perc }}%)</span></div>
            <div class="row">
              <div class="col-md-6 small text-success" title="Бонусы из оценки сотрудника">
                <template v-if="scoredMotivation.motivation_hand_bonus != 0">
                  <span class="cursor-pointer link-underline" @click="showHandMotivationByUserId(scoredMotivation.user.id)">+{{ scoredMotivation.motivation_hand_bonus | toCurrency }}&nbsp;р.</span>
                </template>
                <template v-else>
                  0&nbsp;р.
                </template>
              </div>
              <div class="col-md-6 small text-danger" title="Штрафы из оценки сотрудника">
                <template v-if="scoredMotivation.motivation_hand_fines != 0">
                  <span class="cursor-pointer link-underline" @click="showHandMotivationByUserId(scoredMotivation.user.id)">-{{ scoredMotivation.motivation_hand_fines | toCurrency }}&nbsp;р.</span>
                </template>
                <template v-else>
                  0&nbsp;р.
                </template>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th class="bg-green-light">Итоговый бонус по результатам отчетного периода</th>
          <td class="bg-gray-light">
            {{ (scoredMotivation.motivation_bonus + scoredMotivation.motivation_hand_bonus - scoredMotivation.motivation_hand_fines) | toCurrency }}&nbsp;р.
          </td>
        </tr>
        <tr>
            <th class="bg-green-light">Итоговый бонус с учетом налога</th>
            <td
              class="bg-gray-light"
            >
              {{ (scoredMotivation.motivation_bonus + scoredMotivation.motivation_hand_bonus - scoredMotivation.motivation_hand_fines) / 0.87 | toCurrency }}&nbsp;р.
            </td>
          </tr>

      </table>
    </template>
  </div>
</template>

<script>
    import VueSpeedometer from "vue-speedometer"
    import { toShortMillions } from "@/mixins/textFilters"
    import { mapGetters } from "vuex"
    import {
        API_GET_MOTIVATION_LOAD_RESULTS
    } from '@/constants'

    const TO_ROLES = [
        'TO-head-manager',
        'TO-manager'
    ]
    const LOGIST_ROLES = [
        'logistics-head-manager',
        'logistics-manager'
    ]

    export default {
        components: {
            VueSpeedometer
        },
        mixins: [
            toShortMillions
        ],
        props: {
            isUpdating: { type: Boolean, required: false, default: false },             // If we need to update data
            periodRange: { type: Array,
                required: true,
                default: function () {
                    return []
                }
            },                                                                      // list of months
            selectedPeriod: { type: String, required: false, default: null },        // selected month number
            motivationHeader: { type: String, required: false, default: null },        // header for report
        },
        data() {
            return {
                loading: true,
                additionalGetParameter: '',
                componentRefreshKey: 0,
                scoredMotivation: [],
                periodGoals: {},
                goals: [],
                departamentSegmentStops: {
                    values: [],
                    labels: []
                },
                personalSegmentStops: {
                    values: [],
                    labels: []
                }
            }
        },
        watch: {
            selectedPeriod: {
                handler(value) {
                    this.getScoredMotivation()
                },
            },
            isUpdating: {
                handler(value) {
                    if (value == true) {
                        this.getScoredMotivation()
                    }
                },
            },
        },
        computed: {
            ...mapGetters('auth', ['currentUser']),
        },
        mounted() {
        },
        methods: {
            getScoredMotivation() {
                this.loading = true
                this.scoredMotivation = []

                api.call('get', API_GET_MOTIVATION_LOAD_RESULTS + `?date_from=${this.selectedPeriod}&self_user_operation=1`).then((response) => {
                  this.scoredMotivation = response.data
                    this.periodGoals = this.scoredMotivation.goals
                    this.scoredMotivation = this.scoredMotivation[0]
                    delete this.scoredMotivation.goals
                    this.createSegmentStops()
                    this.loading = false
                    this.$emit('isUpdating', true)
                })
            },
            showMotivationByUserId(finance_ids, user_ids) {
                this.$emit("showMotivationByUserId", finance_ids, user_ids)
            },
            showHandMotivationByUserId(userId) {
                this.$emit("showHandMotivationByUserId", userId)
            },
            createSegmentStops() {
                this.departamentSegmentStops.values = [0]
                this.personalSegmentStops.values = [0]

                if (this.scoredMotivation && this.scoredMotivation.parameters && this.scoredMotivation.parameters[0]) {
                    // let maxSpeedometrSegment = this.toShortMillions(this.scoredMotivation.parameters[0].mpa)
                    let maxSpeedometrSegment = this.toShortMillions(this.periodGoals.minMP.result)
                    this.departamentSegmentStops.values.push(maxSpeedometrSegment)
                    this.personalSegmentStops.values.push(maxSpeedometrSegment)
                }
            },
            tdColorist(key) {
                switch (key) {
                    case 'user_name':
                        return 'td-light-gray '
                        break;
                    default:
                        return ''
                }
            },
            onlyForHeads() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("head-accountant") ||
                    this.currentUser.role.includes("president"))) {
                    return true
                }
                return false
            },
            onlyManager() {
                return [4,6,8].includes(this.scoredMotivation.parameters[0].role_id)
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
<style>
  .table td {
    padding: 1.1rem 0.75rem;
  }
  .table tr.tfoot td,
  .table tr.tfoot{
    background: #f5f5f5!important;
  }
  .table th.bg-green-light{
    background: #CCD3CF!important;
  }
  .table td.bg-gray-light{
    background: #f5f5f5!important;
  }
  .table tfoot th b {
    display: block;
    padding: 12px 0;
    text-transform: uppercase;
  }
  .link-underline {
    border-bottom: 1px dashed #1b1e21;
  }
  .link-underline:hover {
    border: none;
  }
  .table-max-font-size {
    font-size: 120%!important;
  }
</style>
